import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f4c334f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full h-full bg-white border-round-3xl grid justify-content-center align-content-start"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid w-full" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-4 text-center font-bold",
    style: {"font-size":"12px"}
  }, "1ra"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-4 text-center font-bold",
    style: {"font-size":"12px"}
  }, "2da"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-4 text-center font-bold",
    style: {"font-size":"12px"}
  }, "3da")
], -1))
const _hoisted_4 = { class: "col-12 px-2 pb-0 grid align-content-start justify-content-center" }
const _hoisted_5 = { class: "col-12 px-2 pb-0 grid align-content-start justify-content-center" }
const _hoisted_6 = { class: "col-12 px-2 pb-0 grid align-content-start justify-content-center" }
const _hoisted_7 = { class: "col-12 px-2 pb-0 grid align-content-start justify-content-center" }

import { Game } from "@/interfaces/Game";
import { computed } from "vue";
import RdResultBoardMini from "./RdResultBoardMini.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnguilaGameBoard',
  props: {
    info: {},
    isToday: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const time10 = computed(() => props.info?.result["10:00 AM"]?.filter((e) => e.time !== "").map((e) => e.time));
const time01 = computed(() => props.info?.result["01:00 PM"]?.filter((e) => e.time !== "").map((e) => e.time));
const time06 = computed(() => props.info?.result["06:00 PM"]?.filter((e) => e.time !== "").map((e) => e.time));
const time09 = computed(() => props.info?.result["09:00 PM"]?.filter((e) => e.time !== "").map((e) => e.time));

return (_ctx: any,_cache: any) => {
  return (_ctx.info)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.info.logo,
          class: "rectangle-logo border-3 border-white bg-white m-auto mb-0"
        }, null, 8, _hoisted_2),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.info.result['10:00 AM'])
            ? (_openBlock(), _createBlock(RdResultBoardMini, {
                key: 0,
                results: _ctx.info.result['10:00 AM'],
                tod: "10:00 AM",
                time: time10.value,
                icon: "pi pi-sun text-yellow-500",
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "isToday"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.info.result['01:00 PM'])
            ? (_openBlock(), _createBlock(RdResultBoardMini, {
                key: 0,
                results: _ctx.info.result['01:00 PM'],
                tod: "01:00 PM",
                time: time01.value,
                icon: "pi pi-sun text-yellow-500",
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "isToday"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.info.result['06:00 PM'])
            ? (_openBlock(), _createBlock(RdResultBoardMini, {
                key: 0,
                results: _ctx.info.result['06:00 PM'],
                tod: "06:00 PM",
                time: time06.value,
                icon: "pi pi-moon text-surface-300",
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "isToday"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.info.result['09:00 PM'])
            ? (_openBlock(), _createBlock(RdResultBoardMini, {
                key: 0,
                results: _ctx.info.result['09:00 PM'],
                tod: "09:00 PM",
                time: time09.value,
                icon: "pi pi-moon text-surface-300",
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "isToday"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})